import analysisModule from "../analysisModule"
import invoiceModal from "./invoiceViewModal.html"

analysisModule.service("invoiceViewModal", [
    "$q",
    "$http",
    "$modal",
    "$translate",
    function ($q, $http, $modal, $translate) {
        return function (invoices) {
            return $modal.open({
                template: invoiceModal,
                size: "xl",
                controller: ["$q", "$scope", "oldSpreadsheetService", "$filter", "$translate",
                    function ($q, $scope, oldSpreadsheetService, $filter) {
                        $scope.invoices = invoices
                        $scope.entityType = "invoice"

                        $scope.exportSpreadsheet = function () {
                            let spreadsheetName = $translate.instant("invoice.view.export.spreadsheet")
                            let invoicesToExport = $scope.getInvoicesToExport()
                            let headers = Object.keys(invoicesToExport[0])
                            let rows = invoicesToExport.map(function(record) {
                                return Object.values(record)
                            })
                            oldSpreadsheetService.exportData(spreadsheetName, spreadsheetName, headers, rows)
                        }

                        $scope.getInvoicesToExport = function () {
                            var invoicesToExport = []
                            $scope.invoices.forEach(function (invoice) {
                                delete invoice.id
                                delete invoice.version
                                delete invoice.clazz
                                delete invoice.$$hashKey
                                var ordersCodes = []
                                invoice.orders.forEach(function (order) {
                                    ordersCodes.push(order.code)
                                })
                                invoice.lastUpdate = $filter("date")(invoice.lastUpdate, "dd/MM/yyyy H:mm")
                                invoice.orders = ordersCodes
                                invoicesToExport.push(invoice)
                            })
                            return invoicesToExport
                        }
                    }]
            })
        }
    }
])